import { isObject } from '../../common-functions';
import type { DropDownNoSelection, DropDownResult, OptionWithOptionalProperties } from './drop-down-types';

export function isDropDownResult(object: unknown): object is DropDownResult {
  return isObject(object) && object['value'] !== undefined && typeof object.text === 'string';
}

export function isArrayDropDownResult(object: unknown): object is Array<DropDownResult> {
  return Array.isArray(object) && object.length > 0 && object.every(isDropDownResult);
}

export function isDropDownNoSelection(object: unknown): object is DropDownNoSelection {
  return isObject(object) && object['noSelectionValue'] !== undefined;
}

export function isOptionWithOptionalProperties(object: unknown): object is Array<OptionWithOptionalProperties> {
  return (
    isObject(object) &&
    object['position'] !== undefined &&
    object['archivedOption'] !== undefined &&
    object['defaultOption'] !== undefined
  );
}

/**
 * Builds the DOM id for an option so `aria-activedescendant` on the list container can
 * reference the highlighted option. Values are URI-encoded because ids cannot contain whitespace.
 */
export function dropDownOptionDomId(prefix: string, value: unknown): string {
  return `${prefix}-option-${encodeURIComponent(String(value))}`;
}
